import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-reset-password-page',
    templateUrl: 'reset-password-page.component.html'
})
export class ResetPasswordPageComponent implements OnInit {

    isStepTwo = false;

    constructor(
        private route: ActivatedRoute,
    ) { }

    ngOnInit() {
        this.isStepTwo = this.route.snapshot.queryParamMap.has('otp');
    }
}
